export const UNZIP_PDF_REQUESTED = "UNZIP_PDF_REQUESTED";
export const UNZIP_PDF_REQUEST_RECEIVED = "UNZIP_PDF_REQUEST_RECEIVED";
export const UNZIP_PDF_REQUEST_FAILED = "UNZIP_PDF_REQUEST_FAILED";

export const PDF_EXISTS_REQUESTED = "PDF_EXISTS_REQUESTED";
export const PDF_EXISTS_REQUEST_RECEIVED = "PDF_EXISTS_REQUEST_RECEIVED";
export const PDF_EXISTS_REQUEST_FAILED = "PDF_EXISTS_REQUEST_FAILED";

export const requestUnzippedPdf = productCode => ({
  type: UNZIP_PDF_REQUESTED,
  id: productCode
});

export const receiveUnzippedPdf = (productCode, payload) => ({
  type: UNZIP_PDF_REQUEST_RECEIVED,
  id: productCode,
  payload: payload
});

export const requestPdfExists = productCode => ({
  type: PDF_EXISTS_REQUESTED,
  id: productCode
});

export const receivePdfExists = (productCode, payload) => ({
  type: PDF_EXISTS_REQUEST_RECEIVED,
  id: productCode,
  payload: payload
});
